module.exports = __webpack_public_path__ + "static/media/sms-spent.c258fed9.svg";